{
  "confluence-ai-audio.scenario-changeboarding.backButton": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "confluence-ai-audio.scenario-changeboarding.doneButton": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "confluence-ai-audio.scenario-changeboarding.nextButton": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "confluence-ai-audio.scenario-changeboarding.step1Body": [
    {
      "type": 0,
      "value": "Not ready to listen? Add it to your playlist for later or play it on the app."
    }
  ],
  "confluence-ai-audio.scenario-changeboarding.step1Headline": [
    {
      "type": 0,
      "value": "Save it"
    }
  ],
  "confluence-ai-audio.scenario-changeboarding.step2Body": [
    {
      "type": 0,
      "value": "See what’s next, change the order, or start playing."
    }
  ],
  "confluence-ai-audio.scenario-changeboarding.step2Headline": [
    {
      "type": 0,
      "value": "Open playlist"
    }
  ],
  "confluence-ai-audio.scenario-changeboarding.step3Body": [
    {
      "type": 0,
      "value": "Copy and share a link so anyone with access can listen."
    }
  ],
  "confluence-ai-audio.scenario-changeboarding.step3Headline": [
    {
      "type": 0,
      "value": "Share it"
    }
  ],
  "confluence-ai-audio.scenario-changeboarding.stepIndicator": [
    {
      "type": 1,
      "value": "currentStep"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "post-office.audio-button-spotlight.main-heading.no-translate": [
    {
      "type": 0,
      "value": "Welcome to Placements v2 hello there"
    }
  ],
  "post-office.audio-player-spotlight-tour.main-heading.no-translate": [
    {
      "type": 0,
      "value": "Welcome to Placements v2"
    }
  ]
}